export class TreatmentRecommendation {
  dt?: string;
  firstname?: string;
  patient_id?: number;
  treatment_id?: number;
  description?: string;
  version_id?: number;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
